import PlcNotifications from '../../../base/menu/airdome/PlcNotifications';

const plcNotifications: PlcNotifications = {
  categoryName: 'PLC Notifizierung',
  current: 'Aktuell',
  archive: 'Archiv'
};

export default plcNotifications;
